// @ts-nocheck
import React, { HTMLAttributes } from 'react';

export enum NotFoundImage {
  DEFAULT = "no-image.svg",
  EMPLOYEE = "default-user.svg"
}

export type NoImageProps = {
  image?: NotFoundImage
}

export function getNotFoundImage(image: NotFoundImage): NotFoundImage {
  return require("../../../resources/img/" + image);
}

class NoImage extends React.Component<HTMLAttributes<HTMLImageElement> & NoImageProps> {
  render() {
    return (
      <img className={"no-image" + (this.props.className ? " " + this.props.className : "")} alt={"no image"}
           src={require("../../../resources/img/" + (this.props.image ? this.props.image : NotFoundImage.DEFAULT))}/>
    );
  }
}

export default NoImage;
